module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.7fa3879.woff2";